export default __webpack_public_path__ + "static/media/interview.0638b1e0.png";